import { createClient } from '@supabase/supabase-js';
import { apiConfig } from './apiConfig';

const supabaseUrl = apiConfig.supabaseUrl;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase configuration. Check apiConfig.supabaseUrl and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Explicitly enable session persistence in localStorage
    persistSession: true,
    // Automatically refresh tokens before expiry
    autoRefreshToken: true,
    // Use localStorage for session storage (survives browser restart)
    storage: window.localStorage,
    // Detect auth callbacks in URL (e.g., OAuth redirects)
    detectSessionInUrl: true,
    // Use app-specific storage key to avoid conflicts
    storageKey: 'reedle-auth-token',
    // PKCE flow for secure OAuth code exchange (required for mobile deep link callback)
    flowType: 'pkce',
  }
});
